import React, { useCallback } from 'react'

import { useRouter } from 'next/router'

// extraParams example: `urlCallback=${urlCallback}`
// url example: '/login'
// url with params example: '/login?urlCallback=...'

export const useUrlWithExistingParams = (
  url?: string,
  extraPrams?: { [key: string]: string }
) => {
  const { query } = useRouter()

  const navigateWithParams = useCallback(
    (url: string, urlParams?: { [key: string]: string | string[] }) => {
      const mergedQuery = {
        ...urlParams,
      }

      const params = Object.keys(mergedQuery).map((key) => {
        return `${key}=${mergedQuery[key]}`
      })

      if (!params.length) return url

      return `${url}?${params.join('&')}`
    },
    []
  )

  const urlWithParams = React.useMemo(() => {
    return navigateWithParams(url, { ...extraPrams, ...query })
  }, [navigateWithParams, url, extraPrams, query])

  const navigateWithCurrentParams = (url: string) => {
    return navigateWithParams(url, { ...extraPrams, ...query })
  }

  return {
    urlWithParams,
    navigateWithParams,
    navigateWithCurrentParams,
  }
}
